module.exports = __webpack_public_path__ + "img/product-express-three.a5e9a7a.png";